import { useSyncStatus } from "../../features/offline";
import styles from "./shell.module.css";

/**
 * Subtle AppShell offline cue — cached content still works.
 * Hidden while live/synced so it never competes with page chrome.
 */
export default function PlatformOfflineStrip() {
  const { displayPhase, hint } = useSyncStatus();
  if (displayPhase !== "offline") return null;

  return (
    <div className={styles.offlineStrip} role="status" aria-live="polite" data-testid="platform-offline-strip">
      <span>{hint || "You’re offline — showing cached content when available."}</span>
      <button
        type="button"
        className={styles.offlineStripRetry}
        onClick={() => {
          if (typeof window !== "undefined") window.location.reload();
        }}
      >
        Retry
      </button>
    </div>
  );
}
